import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function LinkButton({ handler, disabled }) {
  const {
    t,
  } = useTranslation();

  return (
    <div className="w-100">
      <Button onClick={handler} size="md" className="btn-outline btn-success btn-block" title={t("common.labels.matchSelectedProducts")} disabled={disabled}>
        <i className="fa fa-link" /><span>{t("common.labels.matchPrefix")}</span>
      </Button>
    </div>
  );
}
